import { Injectable } from '@angular/core';

import { ReportPayload, ReportFilters } from '../models/report-payload';
import { ReportType } from '../models/report-types';
import { ReportRecord } from '../models/report-payload';

import { VehicleReportData, VehicleEntry, BasicReportData, VehicleSummary } from '../models/report-viewers';
import { cleanKmLabel } from '../helpers/cleanKmLabel';
import { extractTemperatureAndHumidityData } from 'src/app/shared/helpers/extractTemperatureAndHumidityData';

@Injectable({
  providedIn: 'root',
})
export class ReportFormatterService {
  constructor() { }

  /* ******* CASOS DE USO ******** */
  public collectVehicleRecordsFromReport(vehicleReport: VehicleReportData): ReportRecord[] {
    const allRecords = vehicleReport.vehicles.reduce((acc: ReportRecord[], v) => {
      const recordsWithVehicle = v.records.map(record => ({
        ...record,
        vehiculo: v.vehicle.name,
        imei: v.vehicle.imei, // 👈 si también quieres añadir el IMEI
      }));
      return acc.concat(recordsWithVehicle);
    }, []);

    // Recalcular el campo item para toda la lista combinada
    return allRecords.map((record, index) => ({
      ...record,
      item: index + 1
    }));
  }

  public getReporDatatFormat(payload: ReportPayload): any {
    const formatters: Record<ReportType | string, (payload: ReportPayload) => any> = {
      [ReportType.REPORTE_PARADAS_MOVIMIENTOS]: this.formatReportStopsAndMoves,
      [ReportType.REPORTE_EXCESOS_VELOCIDAD_LIMITE_PERSONALIZADO]: this.formatReportSpeedingLimitCustom,
      [ReportType.REPORTE_ENTRADA_SALIDA_GEOCERCAS]: this.formatReportGeofenceEntryExit,
      [ReportType.REPORTE_COMBUSTIBLE_GENERAL]: this.formatReportFuelGeneral,
      [ReportType.REPORTE_COMBUSTIBLE_RESUMEN]: this.formatReportFuelSummary,
      [ReportType.REPORTE_GENERAL]: this.formatReportGeneral,
      [ReportType.REPORTE_ATENCION_EVENTOS]: this.formatReportAttentionEvent,
      [ReportType.REPORTE_COORDENADAS_GEOCERCAS]: this.formatReportCoordinatesGeofences,
      [ReportType.REPORTE_COORDENADAS_GEOPUNTOS]: this.formatReportCoordinatesGeopoints,
      [ReportType.REPORTE_COORDENADAS_GEOCERCAS_CIRCULARES]: this.formatReportCoordinatesGeopointsCirculares,
      [ReportType.REPORTE_EVENTOS_INTERNO]: this.formatReportEvent,
      [ReportType.REPORTE_EXCESOS_VELOCIDAD_DURACION_TOLERANCIA_NIVEL_RIESGO]: this.formatReportSpeedingDurationToleranceRiskLevel,
      [ReportType.REPORTE_EXCESOS_VELOCIDAD_DIRECCION_DURACION_TOLERANCIA_NIVEL_RIESGO]: this.formatReportSpeedingDurationToleranceRiskLevel,
      [ReportType.REPORTE_EXCESOS_VELOCIDAD_POR_NIVEL]: this.formatReportSpeedingDurationToleranceRiskLevel,
      [ReportType.REPORTE_ESTADO_TRANSMISION]: this.formatReportTransmissionStatus,
      [ReportType.REPORTE_RESUMEN_POR_DIA_NUEVO]: this.formatReportDailySummaryNew,
      [ReportType.REPORTE_POSICION]: this.formatReportPosition,
      [ReportType.REPORTE_EVENTOS]: this.formatReportEvent,
      [ReportType.REPORTE_CHECKLIST]: this.formatReportChecklist,
      [ReportType.REPORTE_RECORRIDO]: this.fomartReportRecorrido,
      [ReportType.REPORTE_RELENTI]: this.fomartReportRelenti,
      [ReportType.REPORTE_OPERATIVIDAD_EQUIPO]: this.fomartReportOperatividadEquipos,
      [ReportType.REPORTE_ESTADO_TRANSMISION_EVENTOS]: this.fomartReportEstateTransmissionEvents,
      [ReportType.REPORTE_MONITOREO_CANTIDAD_EVENTOS_POR_UNIDAD]: this.fomartReportMonitoreoCantidadEventsByUnits,
      [ReportType.REPORTE_CONDUCTORES_ENROLADOS]: this.fomartReportDriverEnrollments,
      [ReportType.REPORTE_EXCESOS_VELOCIDAD_DIRECCION_NIVEL]: this.formatReportSpeedingDirectionLevel,
      [ReportType.REPORTE_EVENTOS_FORMATO_PAXI]: this.formatReportEventosFormatoPaxi,
      [ReportType.REPORTE_PARADAS_MOVIMIENTOS_NUEVO]: this.formatReportStopsAndMoves2,
      [ReportType.REPORTE_PRIMER_MOVIMIENTO]: this.formatReportFirstMovement,
      [ReportType.REPORTE_PARADAS_MOVIMIENTOS_ENHANCED]: this.formatReportStopsAndMoves2,

    };

    return formatters[payload.reportDetails.reportType]?.(payload) ?? payload.data;
  }

  /* ******* FORMATEADOR DE REPORTES ******** */


  // REPORTE DE EXCESO DE VELOCIDAD DIRECCION NIVEL
  // private formatReportSpeedingDirectionLevel(payload: ReportPayload): VehicleReportData {
  //   const vehicleReport: VehicleReportData = { vehicles: [] };
  //   const { filters } = payload;

  //   const splitDateHour = (value?: string) => {
  //     if (!value) return { fecha: undefined, hora: undefined };
  //     const [fecha, hora] = value.split(' ');
  //     return { fecha, hora };
  //   };
  //   // console.log("payload", JSON.stringify(payload));

  //   (payload.data || []).forEach((vehicleData: any) => {
  //     const [vehicleInfo, dataList] = vehicleData;
  //     const imei = vehicleInfo?.[0];
  //     const name = vehicleInfo?.[1];

  //     if (!imei || !Array.isArray(dataList)) return;

  //     const records: ReportRecord[] = dataList.map((row: any, index: number) => {
  //       const record: ReportRecord = {
  //         item: index + 1,
  //         nombre: row.nombre_objeto,
  //         latitud: row.latitud,
  //         longitud: row.longitud,
  //         ubicacion: `${parseFloat(row.latitud).toFixed(6)}, ${parseFloat(row.longitud).toFixed(6)}`,
  //         ubicacionLink: `http://maps.google.com/maps?q=${parseFloat(row.latitud).toFixed(6)},${parseFloat(row.longitud).toFixed(6)}&t=m`,
  //         puntoCercano: row.PC,
  //         zonaGeocerca: row.nombre_zona,
  //         direccionGeocerca: row.direccion_zona,
  //         limiteVelocidadZona: row.velocidad_limite,
  //         referencia: row.referencia,
  //         excesoVelocidad: cleanKmLabel(row.velocidad, false),

  //       };

  //       const setIf = (key: keyof ReportRecord, value: any, condition = true) => {
  //         if (condition && value != null) record[key] = value;
  //       };

  //       if (row.nivel_exceso == 'Nivel I') {
  //         setIf("leve", cleanKmLabel(row.velocidad, false));
  //       } else if (row.nivel_exceso == 'Nivel II') {
  //         setIf("grave", cleanKmLabel(row.velocidad, false));
  //       } else if (row.nivel_exceso == 'Nivel III') {
  //         setIf("muyGrave", cleanKmLabel(row.velocidad, false));
  //       }

  //       // versión básica
  //       setIf("fechaYHora", row.fecha, !filters.includeDateHour);
  //       if (filters.includeDateHour) {
  //         const { fecha, hora } = splitDateHour(row.fecha);
  //         setIf("fecha", fecha);
  //         setIf("hora", hora);
  //       }
  //       //setIf("velocidadMax", cleanKmLabel(row.maxima_velocidad, false));

  //       return record;
  //     });


  //     let vehicle = { name, imei }
  //     vehicleReport.vehicles.push({ records, vehicle });
  //   });

  //   return vehicleReport;
  // }

  private formatReportEventosFormatoPaxi(payload: ReportPayload): VehicleReportData {
    const toNumberOrUndefined = (value: any): number | undefined => {
      const num = Number(value);

      // Si no es un número válido, devolver undefined
      if (isNaN(num)) return undefined;

      // Redondear a máximo 2 decimales
      return parseFloat(num.toFixed(2));
    }
    const { eventColumns } = payload.eventConfig;
    const { filters } = payload;
    const vehicleReport: VehicleReportData = { vehicles: [] };

    (payload.data || []).forEach((vehicleData: any) => {
      const [vehicleInfo, dataList] = vehicleData;
      const imei = vehicleInfo?.[0];
      const name = vehicleInfo?.[1];
      if (!imei || !Array.isArray(dataList)) return;

      const records: ReportRecord[] = dataList.map((row: any, index: number) => {
        const normalized = row.mensaje_alerta.replace(
          /dateTimes:([0-9\-:\s]+)/g,
          'dateTimes:"$1"'
        );
        //console.log('normalized ==> ',normalized);

        const json_mensaje_alerta = Function(`"use strict"; return (${normalized});`)();
        //console.log(json_mensaje_alerta);

        //entrar velocidad de geocerca
        //console.log('row.tramo ==> ',row.tramo);
        const match = row.tramo.match(/\((\d+)\s*km\/h\)/i);
        //console.log('match ==> ',match);
        const velocidad_max_geocerca = match ? Number(match[1]) : null;
        //console.log('velocidad_max_geocerca ==> ',velocidad_max_geocerca); // 90


        // Nivel de velocidad
        const matchNivel = row.nombre_evento.match(/Nivel\s+(I|II|III)\b/i);
        const nivelVelocidad = matchNivel ? matchNivel[1].toUpperCase() : null;
        // console.log('matchNivel');
        // console.log(matchNivel);
        // console.log('nivelVelocidad');
        // console.log(nivelVelocidad);
        let nivel1 = null;
        let nivel2 = null;
        let nivel3 = null;
        if (nivelVelocidad === 'I') {
          nivel1 = cleanKmLabel(row.vel_gps, false);
        } else if (nivelVelocidad === 'II') {
          nivel2 = cleanKmLabel(row.vel_gps, false);
        } else if (nivelVelocidad === 'III') {
          nivel3 = cleanKmLabel(row.vel_gps, false);
        }
        // console.log('nivel1');
        // console.log(nivel1);
        // console.log('nivel2');
        // console.log(nivel2);
        // console.log('nivel3');
        // console.log(nivel3);

        // formato toLocaleString con configuración + ajuste manual. 2026-04-01 19:52:53 --> 2026-04-01 14:52:53
        let fechaInicioLocal = new Date(json_mensaje_alerta.frame[0].dateTimes.replace(' ', 'T') + 'Z').toLocaleString('sv-SE').replace(',', '');
        let fechaFinLocal = new Date(json_mensaje_alerta.frame[json_mensaje_alerta.frame.length - 1].dateTimes.replace(' ', 'T') + 'Z').toLocaleString('sv-SE').replace(',', '');

        // console.log('fechaInicioLocal');
        // console.log(fechaInicioLocal);
        // console.log('fechaFinLocal');
        // console.log(fechaFinLocal);
        // console.log('enlaceArchivo');
        // console.log(row.enlaceArchivo);

        const record: ReportRecord = {
          item: index + 1,
          latitud: parseFloat(row.latitud).toFixed(6),
          longitud: parseFloat(row.longitud).toFixed(6),
          enlaceImagen: row.enlaceImageCIPIA,
          enlaceVideo: row.enlaceVideoCIPIA,
          nombreEvento: row.nombre_evento,

          codigo: row.codigo,
          unidad: row.placa,

          // setIf('velocidadGps', eventColumns.VelGPS ? cleanKmLabel(row.vel_gps, false) : undefined, eventColumns.VelGPS);
          velocidadGps: cleanKmLabel(row.vel_gps, false),
          conductor: row.conductor,
          //velocidad: row.vel_gps,
          ubicacion: `${parseFloat(row.latitud).toFixed(6)}, ${parseFloat(row.longitud).toFixed(6)}`,
          ubicacionLink: `http://maps.google.com/maps?q=${row.latitud.toFixed(6)},${row.longitud.toFixed(6)}&t=m`,
          // setIf('nombreGeocerca', row.tramo, eventColumns.Zona);
          nombreGeocerca: row.tramo,
          referencia: row.referencia,
          duracion: json_mensaje_alerta.seconds,
          velocidadMax: cleanKmLabel(velocidad_max_geocerca, false),
          leve: nivel1,
          grave: nivel2,
          muyGrave: nivel3,
          falta: 1,

          fechaYHoraInicio: fechaInicioLocal,
          fechaYHoraFin: fechaFinLocal,

          fecha: fechaInicioLocal.split(' ')[0],

          fechaInicio: fechaInicioLocal.split(' ')[0],
          horaInicio: fechaInicioLocal.split(' ')[1],
          fechaFin: fechaFinLocal.split(' ')[0],
          horaFin: fechaFinLocal.split(' ')[1],

          // enlaceArchivo: row.enlaceArchivo || '-',

        };

        // const setIf = (
        //   key: keyof ReportRecord,
        //   value: any,
        //   condition = true
        // ) => {
        //   if (condition && value != null) record[key] = value;
        // };


        return record;
      });


      let vehicle = { name, imei }
      vehicleReport.vehicles.push({ records, vehicle });
    });

    return vehicleReport;
  }

  // REPORTE DE EXCESO DE VELOCIDAD DIRECCION CON NIVEL
  private formatReportSpeedingDirectionLevel(payload: ReportPayload): BasicReportData {
    const basicReport: BasicReportData = { records: [] };
    const { filters } = payload;
    let conteobyNivel: number = 1;
    (payload.data[0][1] || []).forEach((row: any, index: any) => {

      const excesos = {
        velocidadLeve: row.vel_leve,
        velocidadGrave: row.vel_grave,
        velocidadMuyGrave: row.vel_muy_grave,
      };

      const record: ReportRecord = {
        item: index + 1,
        fechaYHora: row.fecha_inicio,
        fecha: filters.includeDateHour ? row.fecha_inicio.split(' ')[0] : undefined,
        hora: filters.includeDateHour ? row.fecha_inicio.split(' ')[1] : undefined,

        unidad: row.codigo,

        placa: row.placa,
        zonaGeocerca: row.nombre_zona,

        limiteVelocidadZona: cleanKmLabel(row.v0, false),
        excesoVelocidad: cleanKmLabel(row.velocidad, false),

        isResumen: row.es_resumen,
        direccionGeocerca: row.direccion_zona,

        ...excesos,

        leve: cleanKmLabel(row.vel_leve, false),
        grave: cleanKmLabel(row.vel_grave, false),
        muyGrave: cleanKmLabel(row.vel_muy_grave, false),
        inicioExceso: row.fecha_inicio.split(' ')[1],

        fechaYHoraExceso: row.hora_exceso,
        horaExceso: row.hora_exceso.split(' ')[1], // solo si cheRiesgo

        fechaYHoraFinExceso: row.fin_exceso,
        finExceso: row.fin_exceso.split(' ')[1],
        duracion: row.duracion2,

        idConductor: row.idConductor,
        conductor: row.conductor,

        velocidadADAS: cleanKmLabel(row.velMobileye_ME460, false),
        velocidadGPSSpeed: cleanKmLabel(row.GPS_speed, false),
        velocidadCan: cleanKmLabel(row.can_speed, false),

        satelite: row.sat,

        ubicacion: `${parseFloat(row.latitud).toFixed(6)}, ${parseFloat(row.longitud).toFixed(6)}`,
        ubicacionLink: `http://maps.google.com/maps?q=${parseFloat(row.latitud).toFixed(6)},${parseFloat(row.longitud).toFixed(6)}&t=m`,

        latitud: row.latitud,
        longitud: row.longitud,
      };
      if (!row.es_resumen) {
        record.itemResumen = conteobyNivel
        conteobyNivel++
      }

      basicReport.records.push(record);
    });

    return basicReport;
  }

  // REPORTE DE CONDUCTORES ENROLADOS
  private fomartReportDriverEnrollments(payload: ReportPayload): VehicleReportData {
    console.log("faslkfjasdf", payload)
    const vehicleReport: VehicleReportData = { vehicles: [] };

    (payload.data || []).forEach((vehicleData: any) => {
      let name = vehicleData.name;
      let imei = vehicleData.imei;
      const records: ReportRecord[] = (vehicleData.cipias as any[]).map((row, index) => ({
        item: index + 1,
        vehiculo: name,
        conductor: row.driver?.nombre ?? "Desconocido",
        dni: row.driver?.dni ?? "Desconocido",
        codigoCipia: row.var_cipia,
        fechaEnrolado: row.updated_at.split(" ")[0],
        horaEnrolado: row.updated_at.split(" ")[1],
      }));

      let vehicle = { name, imei }
      vehicleReport.vehicles.push({ records, vehicle });
    })
    return vehicleReport
  }
  public formatDataReportDriverEnrollments(vehicleData: any, vehicleName: string) {
    const records: ReportRecord[] = (vehicleData as any[]).map((row, index) => ({
      item: index + 1,
      vehiculo: vehicleName,
      conductor: row.driver?.nombre ?? "Desconocido",
      dni: row.driver?.dni ?? "Desconocido",
      codigoCipia: row.var_cipia,
      fechaEnrolado: row.updated_at.split(" ")[0],
      horaEnrolado: row.updated_at.split(" ")[1],
    }));
    return records
  }


  // REPORTE DE MONITOREO CANTIDAD EVENTOS POR UNIDAD
  private fomartReportMonitoreoCantidadEventsByUnits(payload: ReportPayload): VehicleReportData {
    const vehicleReport: VehicleReportData = { vehicles: [] };
    const { filters } = payload;

    (payload.data || []).forEach((vehicleData: any) => {
      const [vehicleInfo, dataList] = vehicleData;
      const imei = vehicleInfo?.[0];
      const name = vehicleInfo?.[1];
      if (!imei || !Array.isArray(dataList)) return;

      const records: ReportRecord[] = dataList.map((row: any, index: number) => {
        const record: ReportRecord = {
          item: index + 1,
          estado: row.descripcion_evento,
          fechaYHoraInicio: !filters.includeDateHour ? row.fecha_tracker.split(' ')[0] : undefined,
          fechaInicio: filters.includeDateHour ? row.fecha_tracker.split(' ')[1] : undefined,
          horaInicio: filters.includeDateHour ? row.fecha_tracker.split(' ')[0] : undefined,

          fechaYHoraFin: !filters.includeDateHour ? row.fecha_tracker_fin.split(' ')[0] : undefined,
          fechaFin: filters.includeDateHour ? row.fecha_tracker_fin.split(' ')[1] : undefined,
          horaFin: filters.includeDateHour ? row.fecha_tracker_fin.split(' ')[0] : undefined,


          fechaYHoraServidorInicio: !filters.includeDateHour ? row.fecha_servidor.split(' ')[0] : undefined,
          fechaServidorInicio: filters.includeDateHour ? row.fecha_servidor.split(' ')[1] : undefined,
          horaServidorInicio: filters.includeDateHour ? row.fecha_servidor.split(' ')[0] : undefined,

          fechaYHoraServidorFin: !filters.includeDateHour ? row.fecha_servidor_fin.split(' ')[0] : undefined,
          fechaServidorFin: filters.includeDateHour ? row.fecha_servidor_fin.split(' ')[1] : undefined,
          horaServidorFin: filters.includeDateHour ? row.fecha_servidor_fin.split(' ')[0] : undefined,


          duracion: row.duracion_servidor,
          velocidad: cleanKmLabel(row.vel_gps, false),
          ignicion: row.ignicion,
          puntoCercano: row.PC,
          nombreGeocerca: row.tramo,
          referencia: row.referencia,
          ubicacion: `${parseFloat(row.latitud).toFixed(6)}, ${parseFloat(row.longitud).toFixed(6)}`,
          ubicacionLink: `http://maps.google.com/maps?q=${parseFloat(row.latitud).toFixed(6)},${parseFloat(row.longitud).toFixed(6)}&t=m`,

        };

        return record;
      });


      let vehicle = { name, imei }
      vehicleReport.vehicles.push({ records, vehicle });
    });
    return vehicleReport
  }

  // REPORTE DE TRANSMISSION DE EVENTOS
  private fomartReportEstateTransmissionEvents(payload: ReportPayload): VehicleReportData {
    const vehicleReport: VehicleReportData = { vehicles: [] };
    const { filters } = payload;

    (payload.data || []).forEach((vehicleData: any) => {
      const [vehicleInfo, dataList] = vehicleData;
      const imei = vehicleInfo?.[0];
      const name = vehicleInfo?.[1];
      if (!imei || !Array.isArray(dataList)) return;

      const records: ReportRecord[] = dataList.map((row: any, index: number) => {
        const record: ReportRecord = {
          item: index + 1,
          estado: row.descripcion_evento,
          fechaYHoraInicio: !filters.includeDateHour ? row.fecha_tracker.split(' ')[0] : undefined,
          fechaInicio: filters.includeDateHour ? row.fecha_tracker.split(' ')[1] : undefined,
          horaInicio: filters.includeDateHour ? row.fecha_tracker.split(' ')[0] : undefined,

          fechaYHoraFin: !filters.includeDateHour ? row.fecha_tracker_fin.split(' ')[0] : undefined,
          fechaFin: filters.includeDateHour ? row.fecha_tracker_fin.split(' ')[1] : undefined,
          horaFin: filters.includeDateHour ? row.fecha_tracker_fin.split(' ')[0] : undefined,


          fechaYHoraServidorInicio: !filters.includeDateHour ? row.fecha_servidor.split(' ')[0] : undefined,
          fechaServidorInicio: filters.includeDateHour ? row.fecha_servidor.split(' ')[1] : undefined,
          horaServidorInicio: filters.includeDateHour ? row.fecha_servidor.split(' ')[0] : undefined,

          fechaYHoraServidorFin: !filters.includeDateHour ? row.fecha_servidor_fin.split(' ')[0] : undefined,
          fechaServidorFin: filters.includeDateHour ? row.fecha_servidor_fin.split(' ')[1] : undefined,
          horaServidorFin: filters.includeDateHour ? row.fecha_servidor_fin.split(' ')[0] : undefined,


          duracion: row.duracion_servidor,
          velocidad: cleanKmLabel(row.vel_gps, false),
          ignicion: row.ignicion,
          puntoCercano: row.PC,
          nombreGeocerca: row.tramo,
          referencia: row.referencia,
          ubicacion: `${parseFloat(row.latitud).toFixed(6)}, ${parseFloat(row.longitud).toFixed(6)}`,
          ubicacionLink: `http://maps.google.com/maps?q=${parseFloat(row.latitud).toFixed(6)},${parseFloat(row.longitud).toFixed(6)}&t=m`,

        };

        return record;
      });



      let vehicle = { name, imei }
      vehicleReport.vehicles.push({ records, vehicle });
    });
    return vehicleReport
  }

  // REPORTE DE EXCESO DE VELOCIDAD DURACION TOLERANCIA NIVEL RIESGO
  private fomartReportOperatividadEquipos(payload: ReportPayload): BasicReportData {
    const basicReport: BasicReportData = { records: [] };
    const { filters } = payload;

    (payload.data[0][1] || []).forEach((row: any, index: number) => {
      const record: ReportRecord = {
        item: index + 1,
        codigo: row.codigo,
        placa: row.placa,
        estadoGps: row.estado,

        fechaTracker: !filters.includeDateHour ? row.fecha_tracker : undefined,
        fecha: filters.includeDateHour ? row.fecha_tracker.split(' ')[0] : undefined,
        hora: filters.includeDateHour ? row.fecha_tracker.split(' ')[1] : undefined,


        estadoCipia: row.estado_cipia,
        estado360: `${row.last_fatiga360_fecha} ${row.last_fatiga360_tipo_evento}`,
        caredrive: `${row.last_caredrive_fecha} ${row.last_caredrive_tipo_evento}`,
        alcotester: `${row.last_alcohol_fecha} ${row.last_alcohol_tipo_evento}`,
        adas: `${row.last_adas_fecha} ${row.last_adas_tipo_evento}`,
        can: row.last_can_tipo_evento
      };
      basicReport.records.push(record);
    });

    return basicReport;
  }

  // REPORTE DE RELENTI
  private fomartReportRelenti(payload: ReportPayload): VehicleReportData {
    const vehicleReport: VehicleReportData = { vehicles: [] };
    const { filters } = payload;

    (payload.data || []).forEach((vehicleData: any) => {
      const [vehicleInfo, dataList] = vehicleData;
      const imei = vehicleInfo?.[0];
      const name = vehicleInfo?.[1];
      if (!imei || !Array.isArray(dataList)) return;

      const records: ReportRecord[] = dataList.map((row: any, index: number) => {
        const record: ReportRecord = {
          item: index + 1,
          fechaYHoraInicio: !filters.includeDateHour ? row.fecha_ini.split(' ')[0] : undefined,
          fechaInicio: filters.includeDateHour ? row.fecha_ini.split(' ')[1] : undefined,
          horaInicio: filters.includeDateHour ? row.fecha_ini.split(' ')[0] : undefined,

          fechaYHoraFin: !filters.includeDateHour ? row.fecha_fin.split(' ')[0] : undefined,
          fechaFin: filters.includeDateHour ? row.fecha_fin.split(' ')[1] : undefined,
          horaFin: filters.includeDateHour ? row.fecha_fin.split(' ')[0] : undefined,
          duracion: row.duracion2,
          referencia: row.referencia,
        };

        return record;
      });



      let vehicle = { name, imei }
      vehicleReport.vehicles.push({ records, vehicle });
    });
    return vehicleReport
  }

  // REPORTE DE EXCESO DE VELOCIDAD DURACION TOLERANCIA NIVEL RIESGO
  private fomartReportRecorrido(payload: ReportPayload): BasicReportData {
    const basicReport: BasicReportData = { records: [] };
    (payload.data[0][1] || []).forEach((row: any, index: number) => {
      const record: ReportRecord = {
        item: index + 1,
        codigo: row.codigo,
        placa: row.placa,
        fechaInicio: row.fecha_inicio,
        horaInicio: row.hora_inicio,
        fechaFin: row.fecha_final,
        horaFin: row.hora_final,
        recorrido: cleanKmLabel(row.total_distancia, false),
        tiempoMovimiento: row.tiempo_movimiento,
        tiempoRelenti: row.tiempo_relenti,
        tiempoApagado: row.tiempo_apagado,
        duracionParadas: row.tiempo_parado,
        contadorParadas: row.contador_paradas,
        velocidadMax: cleanKmLabel(row.velocidad_maxima, false),
        velocidadPromedio: cleanKmLabel(row.velocidad_promedio, false)
      };

      basicReport.records.push(record);
    });

    return basicReport;
  }

  // REPORTE DE CHECKLIST
  private formatReportChecklist(payload: ReportPayload): BasicReportData {
    const basicReport: BasicReportData = { records: [] };

    (payload.data.data[0] || []).forEach((row: any, index: number) => {

      let chekclist = row.arrayChecklist
      const record: ReportRecord = {
        item: index + 1,
        codigo: row.cod_interno,
        placa: row.var_plate,
        duracion: row.duration,
        nombreEvento: row.name_event,
        fecha: row.date_event,
        conductor: row.conductorEvent,
        datosChecklist: chekclist,
        linkVideo: row.linkVideo,
        linkImage: row.linkImage,
      };

      basicReport.records.push(record);
    });

    return basicReport;
  }

  // REPORTE DE RESUMEN POR DIA NUEVO
  private formatReportDailySummaryNew(payload: ReportPayload): VehicleReportData {
    const vehicleReport: VehicleReportData = { vehicles: [] };
    const { filters } = payload;

    (payload.data || []).forEach((vehicleData: any) => {
      const [vehicleInfo, dataList] = vehicleData;
      const imei = vehicleInfo?.[0];
      const name = vehicleInfo?.[1];
      if (!imei || !Array.isArray(dataList)) return;

      const records: ReportRecord[] = dataList.map((row: any, index: number) => {
        const record: ReportRecord = {
          item: index + 1,
          codigo: row.codigo,
          placa: row.placa,

          fechaYHoraInicio: !filters.includeDateHour ? row.fecha_inicial : undefined,
          fechaInicio: filters.includeDateHour ? row.fecha_inicial.split(' ')[0] : undefined,
          horaInicio: filters.includeDateHour ? row.fecha_inicial.split(' ')[1] : undefined,

          fechaYHoraFin: !filters.includeDateHour ? row.fecha_final : undefined,
          fechaFin: filters.includeDateHour ? row.fecha_final.split(' ')[0] : undefined,
          horaFin: filters.includeDateHour ? row.fecha_final.split(' ')[1] : undefined,

          recorrido: cleanKmLabel(row.recorrido, false),
          tiempoMovimiento: row.duracion_movimiento,
          tiempoRelenti: row.duracion_ralenti,
          tiempoApagado: row.duracion_apagado,
          duracionParadas: row.duracion_parada,
          contadorParadas: row.contador_parada,
          velocidadMax: cleanKmLabel(row.velocidad_maxima, false),
          velocidadPromedio: cleanKmLabel(row.velocidad_promedio, false),
        };

        return record;
      });



      let vehicle = { name, imei }
      vehicleReport.vehicles.push({ records, vehicle });
    });
    return vehicleReport
  }

  // REPORTE DE ESTADO TRASMISION
  private formatReportTransmissionStatus(payload: ReportPayload): VehicleReportData {
    const vehicleReport: VehicleReportData = { vehicles: [] };
    const { filters } = payload;

    const splitDateHour = (value?: string) => {
      if (!value) return { fecha: undefined, hora: undefined };
      const [fecha, hora] = value.split(' ');
      return { fecha, hora };
    };

    (payload.data || []).forEach((vehicleData: any) => {
      const [vehicleInfo, dataList] = vehicleData;
      const imei = vehicleInfo?.[0];
      const name = vehicleInfo?.[1];
      if (!imei || !Array.isArray(dataList)) return;

      const records: ReportRecord[] = dataList.map((row: any, index: number) => {
        const record: ReportRecord = {
          item: index + 1,
          duracion: row.duracion_servidor,
          velocidad: cleanKmLabel(row.vel_gps, false),
          ignicion: row.ignicion,
          puntoCercano: row.PC,
          nombreGeocerca: row.tramo,
          referencia: row.referencia,

          ubicacion: `${parseFloat(row.latitud).toFixed(6)}, ${parseFloat(row.longitud).toFixed(6)}`,
          ubicacionLink: `http://maps.google.com/maps?q=${parseFloat(row.latitud).toFixed(6)},${parseFloat(row.longitud).toFixed(6)}&t=m`,

          latitud: row.latitud,
          longitud: row.longitud,
        };

        const setIf = (key: keyof ReportRecord, value: any, condition = true) => {
          if (condition && value != null) record[key] = value;
        };

        // inicio
        setIf("fechaYHoraInicio", row.fecha_tracker, !filters.includeDateHour);
        if (filters.includeDateHour) {
          const { fecha, hora } = splitDateHour(row.fecha_tracker);
          setIf("fechaInicio", fecha);
          setIf("horaInicio", hora);
        }

        // fin
        setIf("fechaYHoraFin", row.fecha_tracker_fin, !filters.includeDateHour);
        if (filters.includeDateHour) {
          const { fecha, hora } = splitDateHour(row.fecha_tracker_fin);
          setIf("fechaFin", fecha);
          setIf("horaFin", hora);
        }

        setIf("fechaYHoraServidorInicio", row.fecha_servidor, !filters.includeDateHour);
        if (filters.includeDateHour) {
          const { fecha, hora } = splitDateHour(row.fecha_servidor);
          setIf("fechaServidorInicio", fecha);
          setIf("horaServidorInicio", hora);
        }

        setIf("fechaYHoraServidorFin", row.fecha_servidor_fin, !filters.includeDateHour);
        if (filters.includeDateHour) {
          const { fecha, hora } = splitDateHour(row.fecha_servidor_fin);
          setIf("fechaServidorFin", fecha);
          setIf("horaServidorFin", hora);
        }
        return record;
      });



      let vehicle = { name, imei }
      vehicleReport.vehicles.push({ records, vehicle });
    });
    return vehicleReport
  }

  // REPORTE DE EXCESO DE VELOCIDAD DURACION TOLERANCIA NIVEL RIESGO
  private formatReportSpeedingDurationToleranceRiskLevel(payload: ReportPayload): BasicReportData {
    const basicReport: BasicReportData = { records: [] };
    const { filters } = payload;
    let conteobyNivel: number = 1;
    (payload.data[0][1] || []).forEach((row: any, index: any) => {

      const excesos = payload.reportDetails.reportType != ReportType.REPORTE_EXCESOS_VELOCIDAD_POR_NIVEL ? {
        velocidadLeve: row.vel_leve,
        velocidadGrave: row.vel_grave,
        velocidadMuyGrave: row.vel_muy_grave,
      } :
        {
          velocidadNivel1: row.vel_leve,
          velocidadNivel2: row.vel_grave,
          velocidadNivel3: row.vel_muy_grave,
        }

      const record: ReportRecord = {
        item: index + 1,
        fechaYHora: row.fecha_inicio,
        fecha: filters.includeDateHour ? row.fecha_inicio.split(' ')[0] : undefined,
        hora: filters.includeDateHour ? row.fecha_inicio.split(' ')[1] : undefined,

        unidad: row.codigo,

        placa: row.placa,
        zonaGeocerca: row.nombre_zona,

        limiteVelocidadZona: cleanKmLabel(row.v0, false),
        excesoVelocidad: cleanKmLabel(row.velocidad, false),

        isResumen: row.es_resumen,

        ...excesos,

        leve: cleanKmLabel(row.vel_leve, false),
        grave: cleanKmLabel(row.vel_grave, false),
        muyGrave: cleanKmLabel(row.vel_muy_grave, false),
        inicioExceso: row.fecha_inicio.split(' ')[1],

        fechaYHoraExceso: row.hora_exceso,
        horaExceso: row.hora_exceso.split(' ')[1], // solo si cheRiesgo

        fechaYHoraFinExceso: row.fin_exceso,
        finExceso: row.fin_exceso.split(' ')[1],
        duracion: row.duracion2,

        idConductor: row.idConductor,
        conductor: row.conductor,

        velocidadADAS: cleanKmLabel(row.velMobileye_ME460, false),
        velocidadGPSSpeed: cleanKmLabel(row.GPS_speed, false),
        velocidadCan: cleanKmLabel(row.can_speed, false),

        satelite: row.sat,

        ubicacion: `${parseFloat(row.latitud).toFixed(6)}, ${parseFloat(row.longitud).toFixed(6)}`,
        ubicacionLink: `http://maps.google.com/maps?q=${parseFloat(row.latitud).toFixed(6)},${parseFloat(row.longitud).toFixed(6)}&t=m`,

        latitud: row.latitud,
        longitud: row.longitud,
      };
      if (!row.es_resumen) {
        record.itemResumen = conteobyNivel
        conteobyNivel++
      }

      basicReport.records.push(record);
    });

    return basicReport;
  }

  // REPORTE DE COORDENADAS DE GEOCERCAS
  private formatReportCoordinatesGeofences(payload: ReportPayload): BasicReportData {
    const basicReport: BasicReportData = { records: [] };

    (payload.data[0][1] || []).forEach((row: any, index: number) => {

      const record: ReportRecord = {
        item: index + 1,
        numeroGeo: row.nro,
        nombreGeocerca: row.zone_name,
        latitud: row.lat,
        longitud: row.lng,
        velocidad: cleanKmLabel(row.vel_max, false),
        velocidadMuyGrave: cleanKmLabel(row.vel3_zona, false),
        velocidadGrave: cleanKmLabel(row.vel2_zona, false),
        velocidadTolerancia: cleanKmLabel(row.vel_zona, false),
        zonaColor: row.zone_color,
      };

      basicReport.records.push(record);
    });

    return basicReport;
  }

  // REPORTE DE COORDENADAS DE GEOPUNTOS
  private formatReportCoordinatesGeopoints(payload: ReportPayload): BasicReportData {
    const basicReport: BasicReportData = { records: [] };

    (payload.data[0][1] || []).forEach((row: any, index: number) => {
      const record: ReportRecord = {
        item: index + 1,
        numeroPunto: row.nro,
        nombrePunto: row.geopunto_name,

        latitud: row.lat,
        longitud: row.lng,

        color: row.geopunto_color,

        visibilidadPunto: row.geopunto_visible,
        visibilidadNombre: row.geopunto_nombre_visible,

        latitud2: row.lat_1,
        longitud2: row.lng_1,
      };

      basicReport.records.push(record);
    });

    return basicReport;
  }

  // REPORTE DE GEOCERCAS CIRCULARES
  private formatReportCoordinatesGeopointsCirculares(payload: ReportPayload): BasicReportData {
    const basicReport: BasicReportData = { records: [] };

    (payload.data[0][1] || []).forEach((row: any, i: any) => {
      const record: ReportRecord = {
        item: i + 1,
        numeroGeo: row.nro,
        nombreGeocerca: row.geocerca_name,

        latitud: row.lat,
        longitud: row.lng,

        radio: row.radio,
        diametro: row.diametro,

        velocidad: cleanKmLabel(row.v0, false),
        velocidadTolerancia: cleanKmLabel(row.v1, false),
        velocidadGrave: cleanKmLabel(row.v2, false),
        velocidadMuyGrave: cleanKmLabel(row.v3, false),

        zonaColor: row.geocerca_color,
      };

      basicReport.records.push(record);
    });

    return basicReport;
  }
  // REPORTE DE ATENCION DE EVENTOS
  private formatReportAttentionEvent(payload: ReportPayload): BasicReportData {
    const basicReport: BasicReportData = { records: [] };
    const filters = payload.filters;
    const eventColumns = payload.eventConfig.eventColumns;

    (payload.data[0][1] || []).forEach((row: any, index: number) => {
      const fechaEvaluacionRaw = row.fecha_evaluacion;
      let fechaEvaluacion = "";
      let horaEvaluacion = "";

      if (fechaEvaluacionRaw && fechaEvaluacionRaw !== "-") {
        const partes = fechaEvaluacionRaw.split(" ");
        if (partes.length === 2) {
          fechaEvaluacion = partes[0]; // "2025/09/10"
          horaEvaluacion = partes[1]; // "01:59:17"
        }
      }
      const operadorAux = row.operador_monitoreo || "";
      const parts = operadorAux.split('=').map((part: string) => part.trim());
      const operador = parts[0] || "";
      const otroOperador = parts[1] || "";

      const record: ReportRecord = {
        item: index + 1,
        fechaYHoraEvento: row.fecha_tracker ? row.fecha_tracker : undefined,
        fechaEvento: row.fecha_tracker ? row.fecha_tracker.split(' ')[0] : undefined,
        horaEvento: row.fecha_tracker ? row.fecha_tracker.split(' ')[1] : undefined,

        fechaYHoraServidor: row.fecha_servidor ? row.fecha_servidor : undefined,
        fechaServidor: row.fecha_servidor ? row.fecha_servidor.split(' ')[0] : undefined,
        horaServidor: row.fecha_servidor ? row.fecha_servidor.split(' ')[1] : undefined,

        nombreEvento: row.nombre_evento ? row.nombre_evento : undefined,
        descripcion: row.descripcion_evento ? row.descripcion_evento : undefined,
        codigo: row.codigo ? row.codigo : undefined,
        placa: row.placa ? row.placa : undefined,
        tipoUnidad: row.tipo_unidad ? row.tipo_unidad : undefined,
        idConductor: row.idConductor ? row.idConductor : undefined,
        conductor: row.conductor ? row.conductor : undefined,

        fechaEvaluacion: fechaEvaluacion ? (fechaEvaluacion) : undefined,
        horaEvaluacion: horaEvaluacion ? (horaEvaluacion) : undefined,

        criterioEvaluacion: row.criterio_evaluacion || "",
        observacion: row.observacion_evaluacion ? row.observacion_evaluacion : undefined,
        comunicacionRadial: eventColumns.ComRadial ? row.ComRadial : undefined,
        velocidadMobileye: eventColumns.VelMobileye ? cleanKmLabel(row.vel_mobileye, false) : undefined,
        velocidadGps: eventColumns.VelGPS ? cleanKmLabel(row.vel_gps, false) : undefined,
        velocidadGPSSpeed: eventColumns.VelGPSspeed ? cleanKmLabel(row.vel_gps_speed, false) : undefined,
        velocidadCan: eventColumns.VelCAN ? cleanKmLabel(row.vel_can, false) : undefined,
        velocidadEco: eventColumns.VelECO ? cleanKmLabel(row.vel_eco, false) : undefined,
        nombreGeocerca: row.tramo ? row.tramo : undefined,
        puntoCercano: row.PC ? row.PC : undefined,
        ubicacion: `${parseFloat(row.latitud).toFixed(6)}, ${parseFloat(row.longitud).toFixed(6)}`,
        ubicacionLink: `http://maps.google.com/maps?q=${row.latitud.toFixed(6)},${row.longitud.toFixed(6)}&t=m`,
        referencia: row.referencia ? row.referencia : undefined,
        enlaceArchivo: row.enlaceArchivo ? (row.enlaceArchivo || "") : undefined,
        operadorMonitoreo: operador ? operador : undefined,
        uuid: row.uuid_event,

        trackerImei: row.tracker_imei,
        nombreObjeto: row.nombre_objeto,

        // Sin relación directa con eventColumns (se mantienen tal cual estaban)
        slug: row.slug,
        criterioId: row.criterion_id || undefined,
        newDriver: null,
        isUnknownDriver: false,
        parametros: row.parametros,
        senalesPosibleFatiga: row.senales_posible_fatiga,
        identificacionVideo: row.identificacion_video,
        isConfirmed: row.is_confirmed,
        valoracionEvento: Number(row.valoracion_evento),
        eventoId: row.evento_id,
        latitud: row.latitud,
        longitud: row.longitud,
        enlaceImagen: row.enlaceImageCIPIA,
        enlaceVideo: row.enlaceVideoCIPIA,
        otroOperadorMonitoreo: otroOperador,
        esAntiguoOperador: row.es_antiguo_operador
      };

      basicReport.records.push(record);
    });

    return basicReport;
  }

  // REPORTE GENERAL
  private formatReportGeneral(payload: ReportPayload): VehicleReportData {
    const vehicleReport: VehicleReportData = { vehicles: [] };
    const { filters } = payload;

    const splitDateHour = (value?: string) => {
      if (!value) return { fecha: undefined, hora: undefined };
      const [fecha, hora] = value.split(' ');
      return { fecha, hora };
    };

    (payload.data || []).forEach((vehicleData: any) => {
      const [vehicleInfo, dataList, parameters, resumen] = vehicleData;
      const imei = vehicleInfo?.[0];
      const name = vehicleInfo?.[1]; 
      if (!imei || !Array.isArray(dataList)) return;

      const records: ReportRecord[] = dataList.map((row: any, index: number) => {
        const record: ReportRecord = {
          item: index + 1,
          velocidadCan: cleanKmLabel(row.velCAN, false),
          velocidad: cleanKmLabel(row.velGPS, false),
          velocidad360: cleanKmLabel(row.velGPS, false),
          velocidadGPSSpeed: cleanKmLabel(row.velGPS_speed, false),
          velocidadMobileye: cleanKmLabel(row.velMobileye_ME460, false),
          velocidadEco: cleanKmLabel(row.velECO, false),

          errorMobileye_ME427: row.errorMobileye_ME427,
          estadoDuot2: row.DUOT2state,

          rpm: row.RxM,
          rpmECO: row.RPMAlta,
          nivelCombustible: row.cNivel,
          combustibleRestante: row.cRestante,
          contactoMotor: row.cMotor,

          odometro: row.odometro,
          altitud: row.altitud,
          angulo: row.angulo,
          alimentacionGPS: row.alimentGps,
          satelite: row.satelite,
          reconocimientoFacial: row.recFacial,

          temperaturaGps: row.temperaturaGps,
          temperaturaEye: row.eyeTemperature,
          temperaturaBle: row.bleTemperature,

          humedadEye: row.eyeHumedad,
          humedadBle: row.bleHumedad,

          nivelBateria: row.nivelBateria,
          nivelCobertura: row.nivelCobertura,
          temperatureEye: row.temperatureEye,

          ignicion: row.onOff,
          alcoholemia: row.alcohol_nombre,
          parametros: row.parametros,

          latitud: row.lat,
          longitud: row.lng,

          referencia: row.referencia,
          fatiga: row.fatiga,

          frenadaBrusca: row.fBrusca,
          aceleracionBrusca: row.aBrusca,
          puntoCercano: row.pCercano,
          nombreGeocerca: row.geocerca,
          direccionGeocerca: row.direccionGeocerca,
          voltageLevel: row.voltageLevel,
        };

        const setIf = (key: keyof ReportRecord, value: any, condition = true) => {
          if (condition && value != null) record[key] = value;
        };

        // Fecha y hora
        setIf("fechaYHora", row.fecha, !filters.includeDateHour);
        if (filters.includeDateHour) {
          const { fecha, hora } = splitDateHour(row.fecha);
          setIf("fecha", fecha);
          setIf("hora", hora);
        }

        // Fecha y hora Servidor
        setIf("fechaYHoraServidor", row.fServidor, (!filters.includeDateHour && parameters.fServidor));
        if (filters.includeDateHour && parameters.fServidor) {
          const { fecha, hora } = splitDateHour(row.fServidor);
          setIf("fechaServidor", fecha);
          setIf("horaServidor", hora);
        }

        // Ubicación
        if (row.lat && row.lng) {
          const lat = parseFloat(row.lat).toFixed(6);
          const lon = parseFloat(row.lng).toFixed(6);
          record.ubicacion = `${lat}, ${lon}`;
          record.ubicacionLink = `http://maps.google.com/maps?q=${row.lat.toFixed(6)},${row.lng.toFixed(6)}&t=m`;
        }

        return record;
      });

      let summary: VehicleSummary = {
        gpsSpeeding: resumen[0],                         // execesosVelocidadGPS
        ecoSpeeding: resumen[1],                         // execesosVelocidadECO
        canSpeeding: resumen[2],                         // execesosVelocidadCAN
        totalFatigue: parameters.fatiga ? resumen[3] : undefined,   // totalFatigas
        hardBraking: parameters.fBrusca ? resumen[5] : undefined,   // frenadaBrusca
        highRpm: parameters.RPMAlta ? resumen[6] : undefined,       // rpmAlta
        alcohol: parameters.alcoholemia ? resumen[7] : undefined    // alcoholemia
      }

      let vehicle = { name, imei }
      vehicleReport.vehicles.push({ records, vehicle, summary });
    });
    return vehicleReport
  }
  public formatRecordsReportGeneral(data: any, filters: any): VehicleEntry {
    const splitDateHour = (value?: string) => {
      if (!value) return { fecha: undefined, hora: undefined };
      const [fecha, hora] = value.split(' ');
      return { fecha, hora };
    };
    const [vehicleInfo, dataList, parameters, resumen] = data[0];
    const imei = vehicleInfo?.[0];
    const name = vehicleInfo?.[1];
    const records: ReportRecord[] = dataList.map((row: any, i: number) => {
      const record: ReportRecord = {
        item: i + 1,
        velocidadCan: cleanKmLabel(row.velCAN, false),
        // velocidadGps: cleanKmLabel(row.velGPS, false),
        velocidad: cleanKmLabel(row.velGPS, false),
        velocidad360: cleanKmLabel(row.velGPS, false),
        velocidadGPSSpeed: cleanKmLabel(row.velGPS_speed, false),
        velocidadMobileye: cleanKmLabel(row.velMobileye_ME460, false),
        velocidadEco: cleanKmLabel(row.velECO, false),

        errorMobileye_ME427: row.errorMobileye_ME427,
        estadoDuot2: row.DUOT2state,

        rpm: row.RxM,
        rpmECO: row.RPMAlta,
        nivelCombustible: row.cNivel,
        combustibleRestante: row.cRestante,
        contactoMotor: row.cMotor,

        odometro: row.odometro,
        altitud: row.altitud,
        angulo: row.angulo,
        alimentacionGPS: row.alimentGps,
        satelite: row.satelite,
        reconocimientoFacial: row.recFacial,
        ignicion: row.onOff,
        alcoholemia: row.alcohol_nombre,
        parametros: row.parametros,

        temperaturaEye: row.eyeTemperature,
        temperaturaBle: row.bleTemperature,
        humedadEye: row.eyeHumedad,
        humedadBle: row.bleHumedad,
        latitud: row.lat,
        longitud: row.lng,

        referencia: row.referencia,
        fatiga: row.fatiga,

        frenadaBrusca: row.fBrusca,
        aceleracionBrusca: row.aBrusca,
        puntoCercano: row.pCercano,
        nombreGeocerca: row.geocerca,
        direccionGeocerca: row.direccionGeocerca
      };

      const setIf = (key: keyof ReportRecord, value: any, condition = true) => {
        if (condition && value != null) record[key] = value;
      };

      // Fecha y hora
      setIf("fechaYHora", row.fecha, !filters.includeDateHour);
      if (filters.includeDateHour) {
        const { fecha, hora } = splitDateHour(row.fecha);
        setIf("fecha", fecha);
        setIf("hora", hora);
      }

      // Fecha y hora Servidor
      setIf("fechaYHoraServidor", row.fServidor, (!filters.includeDateHour));
      if (filters.includeDateHour) {
        const { fecha, hora } = splitDateHour(row.fServidor);
        setIf("fechaServidor", fecha);
        setIf("horaServidor", hora);
      }

      // Ubicación
      if (row.lat && row.lng) {
        const lat = parseFloat(row.lat).toFixed(6);
        const lon = parseFloat(row.lng).toFixed(6);
        record.ubicacion = `${lat}, ${lon}`;
        record.ubicacionLink = `http://maps.google.com/maps?q=${row.lat.toFixed(6)},${row.lng.toFixed(6)}&t=m`;
      }

      return record;
    });
    let summary: VehicleSummary = {
      gpsSpeeding: resumen[0],                         // execesosVelocidadGPS
      ecoSpeeding: resumen[1],                         // execesosVelocidadECO
      canSpeeding: resumen[2],                         // execesosVelocidadCAN
      totalFatigue: parameters.fatiga ? resumen[3] : undefined,   // totalFatigas
      hardBraking: parameters.fBrusca ? resumen[5] : undefined,   // frenadaBrusca
      highRpm: parameters.RPMAlta ? resumen[6] : undefined,       // rpmAlta
      alcohol: parameters.alcoholemia ? resumen[7] : undefined    // alcoholemia
    }

    let vehicle = { name, imei }
    return { records, vehicle, summary };
  }

  // REPORTE DE COMBUSTIBLE GENERAL
  private formatReportFuelGeneral(payload: ReportPayload): VehicleReportData {
    const vehicleReport: VehicleReportData = { vehicles: [] };
    const { filters } = payload;

    const splitDateHour = (value?: string) => {
      if (!value) return { fecha: undefined, hora: undefined };
      const [fecha, hora] = value.split(' ');
      return { fecha, hora };
    };

    (payload.data || []).forEach((vehicleData: any) => {
      const [vehicleInfo, dataList, resumen] = vehicleData;
      const imei = vehicleInfo?.[0];
      const name = vehicleInfo?.[1];
      if (!imei || !Array.isArray(dataList)) return;

      const records: ReportRecord[] = dataList.map((row: any, index: number) => {
        const record: ReportRecord = {
          item: index + 1,
          // Datos de CAN y combustible
          velocidadCan: cleanKmLabel(row.can_speed, false),
          nivelCombustible: row.fuel_level,
          consumoCombustible: row.fuel_used,
          consumoHrfc: row.can_HRFC,

          // Otros datos de vehículo
          maximaVelocidad: cleanKmLabel(row.vel_max, false),
          zonaCercana: row.ZC,
          combustibleRestante: row.combusrestante,
          contactoMotor: row.di4,
          odometro: row.can_dist,
          odometroVirtual: row.virtual_odom,

          // Otros sensores
          canRpm: row.can_rpm,
          altitud: row.altitude,
        };

        // Fecha y hora (condicional)
        if (!filters.includeDateHour && row.fecha != null) {
          record.fechaYHora = row.fecha;
        }
        if (filters.includeDateHour) {
          const { fecha, hora } = splitDateHour(row.fecha);
          if (fecha != null) record.fecha = fecha;
          if (hora != null) record.hora = hora;
        }

        // Ubicación (condicional)
        if (row.latitud && row.longitud) {
          const lat = parseFloat(row.latitud).toFixed(6);
          const lon = parseFloat(row.longitud).toFixed(6);
          record.ubicacion = `${lat}, ${lon}`;
          record.ubicacionLink = `http://maps.google.com/maps?q=${row.latitud},${row.longitud}&t=m`;
          record.latitud = row.latitud;
          record.longitud = row.longitud;
        }

        return record;
      });

      let summary: VehicleSummary = {
        distanceTraveled: resumen[0],        // distanciaRecorrida
        fuelConsumed: resumen[1],            // combustibleConsumido
        hrfFuelConsumed: resumen[2],         // combustibleHRFCConsumido
        gallonPerformance: resumen[3]        // rendimientoGalon
      }
      let vehicle = { name, imei }
      vehicleReport.vehicles.push({ records, vehicle, summary });
    });
    return vehicleReport
  }

  // REPORTE DE COMBUSTIBLE RESUMEN
  private formatReportFuelSummary(payload: ReportPayload): BasicReportData {

    const basicReport: BasicReportData = { records: [] };

    (payload.data[0][1] || []).forEach((row: any, index: number) => {

      const record: ReportRecord = {
        item: index + 1,
        placa: row.placa,
        codigo: row.codigo,
        fechaInicioGps: row.fecha_inicio,
        horaInicioGps: row.hora_inicio,
        fechaFinGps: row.fecha_final,
        horaFinGps: row.hora_final,
        distanciaRecorrida: cleanKmLabel(row.total_distancia, false),
        consumoCombustible: row.combustible_consumido,
        rendimientoPorGalon: row.rendimiento_por_galon,
        velocidadPromedio: cleanKmLabel(row.velocidad_promedio, false),
        tiempoMovimiento: row.tiempo_movimiento,
        tiempoRelenti: row.tiempo_relenti,
        tiempoApagado: row.tiempo_apagado,
        odometroInicial: row.odometro_ini,
        odometroFinal: row.odometro_fin,
      };
      basicReport.records.push(record);
    });
    return basicReport
  }

  // REPORTE DE ENTRADA Y SALIDA DE GEOCERCAS
  private formatReportGeofenceEntryExit(payload: ReportPayload): VehicleReportData {
    const vehicleReport: VehicleReportData = { vehicles: [] };
    const { filters } = payload;

    const splitDateHour = (value?: string) => {
      if (!value) return { fecha: undefined, hora: undefined };
      const [fecha, hora] = value.split(' ');
      return { fecha, hora };
    };

    (payload.data || []).forEach((vehicleData: any) => {
      const [vehicleInfo, dataList] = vehicleData;
      const imei = vehicleInfo?.[0];
      const name = vehicleInfo?.[1];
      if (!imei || !Array.isArray(dataList)) return;

      const records: ReportRecord[] = dataList.map((row: any, index: number) => {
        const record: ReportRecord = {
          item: index + 1,
          latitud: row.latitud,
          longitud: row.longitud,
          ubicacion: `${parseFloat(row.latitud).toFixed(6)}, ${parseFloat(row.longitud).toFixed(6)}`,
          ubicacionLink: `http://maps.google.com/maps?q=${parseFloat(row.latitud).toFixed(6)},${parseFloat(row.longitud).toFixed(6)}&t=m`,
          puntoCercano: row.PC,
          duracion: row.duracion,
          nombreGeocerca: row.nombre_zona,

        };

        const setIf = (key: keyof ReportRecord, value: any, condition = true) => {
          if (condition && value != null) record[key] = value;
        };

        // inicio
        setIf("fechaYHoraEntrada", row.fecha, !filters.includeDateHour);
        if (filters.includeDateHour) {
          const { fecha, hora } = splitDateHour(row.fecha);
          setIf("fechaEntrada", fecha);
          setIf("horaEntrada", hora);
        }

        // fin
        setIf("fechaYHoraSalida", row.fecha_out, !filters.includeDateHour);
        if (filters.includeDateHour) {
          const { fecha, hora } = splitDateHour(row.fecha_out);
          setIf("fechaSalida", fecha);
          setIf("horaSalida", hora);
        }

        return record;
      });


      let vehicle = { name, imei }
      vehicleReport.vehicles.push({ records, vehicle });
    });

    return vehicleReport;
  }

  // REPORTE DE EXCESO DE VELOCIDAD LIMITE PERSONALIZADO
  private formatReportSpeedingLimitCustom(payload: ReportPayload): VehicleReportData {
    const vehicleReport: VehicleReportData = { vehicles: [] };
    const { filters } = payload;

    const splitDateHour = (value?: string) => {
      if (!value) return { fecha: undefined, hora: undefined };
      const [fecha, hora] = value.split(' ');
      return { fecha, hora };
    };

    (payload.data || []).forEach((vehicleData: any) => {
      const [vehicleInfo, dataList] = vehicleData;
      const imei = vehicleInfo?.[0];
      const name = vehicleInfo?.[1];

      if (!imei || !Array.isArray(dataList)) return;

      const records: ReportRecord[] = dataList.map((row: any, index: number) => {
        const record: ReportRecord = {
          item: index + 1,
          latitud: row.latitud,
          longitud: row.longitud,
          ubicacion: `${parseFloat(row.latitud).toFixed(6)}, ${parseFloat(row.longitud).toFixed(6)}`,
          ubicacionLink: `http://maps.google.com/maps?q=${parseFloat(row.latitud).toFixed(6)},${parseFloat(row.longitud).toFixed(6)}&t=m`,
          puntoCercano: row.PC
        };

        const setIf = (key: keyof ReportRecord, value: any, condition = true) => {
          if (condition && value != null) record[key] = value;
        };

        if (filters.includeDuracion) {
          // inicio
          setIf("fechaYHoraInicio", row.fecha_inicial, !filters.includeDateHour);
          if (filters.includeDateHour) {
            const { fecha, hora } = splitDateHour(row.fecha_inicial);
            setIf("fechaInicio", fecha);
            setIf("horaInicio", hora);
          }

          // fin
          setIf("fechaYHoraFin", row.fecha_final, !filters.includeDateHour);
          if (filters.includeDateHour) {
            const { fecha, hora } = splitDateHour(row.fecha_final);
            setIf("fechaFin", fecha);
            setIf("horaFin", hora);
          }

          // datos de duración
          setIf("duracion", row.duracion);
          setIf("cantTramas", row.cant_tramas);
          setIf("tramas", row.string_tramas);
          setIf("velocidadMin", cleanKmLabel(row.vel_min, false));
          setIf("velocidadMax", cleanKmLabel(row.vel_max, false));
          setIf("zonaCercana", row.ZC);
        } else {
          // versión básica
          setIf("nombre", row.nombre);
          setIf("fechaYHora", row.fecha, !filters.includeDateHour);
          if (filters.includeDateHour) {
            const { fecha, hora } = splitDateHour(row.fecha);
            setIf("fecha", fecha);
            setIf("hora", hora);
          }
          setIf("velocidadMax", cleanKmLabel(row.maxima_velocidad, false));
          setIf("referencia", row.referencia);
        }

        return record;
      });


      let vehicle = { name, imei }
      vehicleReport.vehicles.push({ records, vehicle });
    });

    return vehicleReport;
  }

  // REPORTE DE POSICIÓN
  private formatReportPosition(payload: ReportPayload): BasicReportData {
    const basicReport: BasicReportData = { records: [] };
    const filters = payload.filters;

    (payload.data || []).forEach((row: any, index: number) => {
      const record: ReportRecord = {
        item: index + 1,
        codigo: row.codigo,
        placa: row.placa ? row.placa.replace(/-/g, '') : '',
        estado: row.estado,
        conductor: row.conductor,
        odometro: row.odometro,
        latitud: row.latitud,
        longitud: row.longitud,
        ubicacion: `${parseFloat(row.latitud).toFixed(6)}, ${parseFloat(row.longitud).toFixed(6)}`,
        ubicacionLink: `http://maps.google.com/maps?q=${parseFloat(row.latitud).toFixed(6)},${parseFloat(row.longitud).toFixed(6)}&t=m`,
        nombreGeocerca: row.tramo,
        referencia: row.referencia,
      };

      const setIf = (
        key: keyof ReportRecord,
        value: any,
        condition = true
      ) => {
        if (condition && value != null) record[key] = value;
      };

      setIf('fechaYHora', row.fecha, !filters.includeDateHour);

      if (filters.includeDateHour) {
        const [fecha, hora] = row.fecha.split(' ');
        setIf('fecha', fecha);
        setIf('hora', hora);
      }
      setIf('velocidadGps', row.velocidad !== "-" ? cleanKmLabel(row.velocidad, false) : row.velocidad);
      setIf('velocidadCan', row.velocidad_can !== "-" ? cleanKmLabel(row.velocidad_can, false) : row.velocidad_can);

      basicReport.records.push(record);
    });

    return basicReport;
  }

  // REPORTE EVENTOS
  private formatReportEvent(payload: ReportPayload): VehicleReportData {
    const toNumberOrUndefined = (value: any): number | undefined => {
      const num = Number(value);

      // Si no es un número válido, devolver undefined
      if (isNaN(num)) return undefined;

      // Redondear a máximo 2 decimales
      return parseFloat(num.toFixed(2));
    }
    const { eventColumns } = payload.eventConfig;
    const { filters } = payload;
    const vehicleReport: VehicleReportData = { vehicles: [] };

    (payload.data || []).forEach((vehicleData: any) => {
      const [vehicleInfo, dataList] = vehicleData;
      const imei = vehicleInfo?.[0];
      const name = vehicleInfo?.[1];
      if (!imei || !Array.isArray(dataList)) return;

      const records: ReportRecord[] = dataList.map((row: any, index: number) => {
        const record: ReportRecord = {
          item: index + 1,
          latitud: row.latitud,
          longitud: row.longitud,
          enlaceImagen: row.enlaceImageCIPIA,
          enlaceVideo: row.enlaceVideoCIPIA,
          nombreEvento: row.nombre_evento,
        };

        const setIf = (
          key: keyof ReportRecord,
          value: any,
          condition = true
        ) => {
          if (condition && value != null) record[key] = value;
        };

        // Fecha/Hora Evento
        setIf(
          'fechaYHoraEvento',
          row.fecha_tracker,
          !filters.includeDateHour && eventColumns.Fecha
        );
        if (
          filters.includeDateHour &&
          eventColumns.Fecha &&
          row.fecha_tracker
        ) {
          const [fecha, hora] = row.fecha_tracker.split(' ');
          setIf('fechaEvento', fecha);
          setIf('horaEvento', hora);
        }

        // Fecha/Hora Servidor
        setIf(
          'fechaYHoraServidor',
          row.fecha_servidor,
          !filters.includeDateHour && eventColumns.FechaServidor
        );
        if (
          filters.includeDateHour &&
          eventColumns.FechaServidor &&
          row.fecha_servidor
        ) {
          const [fecha, hora] = row.fecha_servidor.split(' ');
          setIf('fechaServidor', fecha);
          setIf('horaServidor', hora);
        }

        setIf('motivo', row.motivo, eventColumns.ConMasDetalle);
        setIf('nombreEvento', row.nombre_evento, eventColumns.NombreEvento);
        setIf('descripcion', row.descripcion_evento, eventColumns.Evento);
        setIf('codigo', row.codigo, eventColumns.Codigo);
        setIf('placa', row.placa, eventColumns.Placa);
        setIf('tipoUnidad', row.tipo_unidad, eventColumns.TipoUnidad);
        setIf('idConductor', row.idConductor, eventColumns.IdConductor);
        setIf('conductor', row.conductor, eventColumns.Conductor);
        setIf('velocidadMobileye', eventColumns.VelMobileye ? cleanKmLabel(row.vel_mobileye, false) : undefined, eventColumns.VelMobileye);
        setIf('velocidadGps', eventColumns.VelGPS ? cleanKmLabel(row.vel_gps, false) : undefined, eventColumns.VelGPS);
        setIf('velocidadGPSSpeed', eventColumns.VelGPSspeed ? cleanKmLabel(row.vel_gps_speed, false) : undefined, eventColumns.VelGPSspeed);
        setIf('velocidadCan', eventColumns.VelCAN ? cleanKmLabel(row.vel_can, false) : undefined, eventColumns.VelCAN);
        setIf('velocidadEco', eventColumns.VelECO ? cleanKmLabel(row.vel_eco, false) : undefined, eventColumns.VelECO);
        setIf('nombreGeocerca', row.tramo, eventColumns.Zona);
        setIf('puntoCercano', row.PC, eventColumns.PuntoCercano);
        setIf(
          'ubicacion',
          row.latitud && row.longitud
            ? `${parseFloat(row.latitud).toFixed(6)}, ${parseFloat(
              row.longitud
            ).toFixed(6)}`
            : undefined,
          eventColumns.Ubicacion
        );
        record.ubicacionLink = eventColumns.Ubicacion ? `http://maps.google.com/maps?q=${parseFloat(row.latitud).toFixed(6)},${parseFloat(row.longitud).toFixed(6)}&t=m` : "";

        setIf('referencia', row.referencia, eventColumns.Referencia);
        setIf(
          'enlaceArchivo',
          row.enlaceArchivo || '',
          eventColumns.EnlaceArchivo
        );
        setIf('parametros', row.parametros, eventColumns.Parametros);

        if (eventColumns.temperatura || eventColumns.humedad) {
          let {
            temperatura_min,
            temperatura_max,
            humedad_min,
            humedad_max,
            temperaturas,
            humedades,
          } = extractTemperatureAndHumidityData(row.mensaje_alerta, row.slug);

          let temperaturaDetail = "";
          let humedadDetail = "";
          if (temperaturas.length > 0) {
            temperaturaDetail = temperaturas
              .filter(t => t.sensor !== undefined && t.sensor !== null && t.sensor !== "")
              .map(t => {
                const valor = t.temperatura !== undefined && t.temperatura !== null
                  ? parseFloat(t.temperatura.toFixed(2))
                  : '';
                return `Sensor ${t.sensor}: ${valor}`;
              })
              .join("\n");
          } else if (humedades.length > 0) {
            humedadDetail = humedades
              .filter(h => h.sensor !== undefined && h.sensor !== null && h.sensor !== "")
              .map(h => {
                const valor = h.humedad !== undefined && h.humedad !== null
                  ? parseFloat(h.humedad.toFixed(2))
                  : '';
                return `Sensor ${h.sensor}: ${valor}`;
              })
              .join("\n");
          }


          if (eventColumns.temperatura) {
            setIf('temperaturaMin', temperatura_min || "-");
            setIf('temperaturaMax', temperatura_max || "-");
            setIf('temperaturas', temperaturaDetail || "-");
          }
          if (eventColumns.humedad) {
            setIf('humedadMin', humedad_min || "-");
            setIf('humedadMax', humedad_max || "-");
            setIf('humedades', humedadDetail || "-");
          }
        }


        return record;
      });


      let vehicle = { name, imei }
      vehicleReport.vehicles.push({ records, vehicle });
    });

    return vehicleReport;
  }

  // REPORTE DE PARADAS Y MOVIMIENTOS
  private formatReportStopsAndMoves(payload: ReportPayload): VehicleReportData {
    const { filters } = payload;

    const vehicleReport: VehicleReportData = { vehicles: [] };

    (payload.data || []).forEach((vehicleData: any) => {
      const [vehicleInfo, dataList, parameters, resumen] = vehicleData;
      const imei = vehicleInfo?.[0];
      const name = vehicleInfo?.[1];
      if (!imei || !Array.isArray(dataList)) return;
      const records: ReportRecord[] = dataList.map((row: any, index: number) => {
        const record: ReportRecord = {
          item: index + 1,
          estado: row.estado,
          duracion: row.duracion,
          latitud: row.latitud,
          longitud: row.longitud,
        };

        const setIf = (
          key: keyof ReportRecord,
          value: any,
          condition = true
        ) => {
          if (condition && value != null) record[key] = value;
        };

        setIf(
          'fechaYHoraInicio',
          row.fecha,
          !filters.includeDateHour
        );
        if (
          filters.includeDateHour &&
          row.fecha
        ) {
          const [fecha, hora] = row.fecha.split(' ');
          setIf('fechaInicio', fecha);
          setIf('horaInicio', hora);
        }

        setIf(
          'fechaYHoraFin',
          row.fechasig,
          !filters.includeDateHour
        );
        if (
          filters.includeDateHour &&
          row.fechasig
        ) {
          const [fecha, hora] = row.fechasig.split(' ');
          setIf('fechaFin', fecha);
          setIf('horaFin', hora);
        }

        setIf(
          'ubicacion',
          row.latitud && row.longitud
            ? `${parseFloat(row.latitud).toFixed(6)}, ${parseFloat(
              row.longitud
            ).toFixed(6)}`
            : undefined,
          filters.includeParadas
        );
        record.ubicacionLink = filters.includeParadas ? `http://maps.google.com/maps?q=${parseFloat(row.latitud).toFixed(6)},${parseFloat(row.longitud).toFixed(6)}&t=m` : "";

        setIf('distanciaRecorrida', filters.includeMovimientos ? cleanKmLabel(row.recorrido, false) : undefined, filters.includeMovimientos);
        setIf('velocidadMaxGps', filters.includeMovimientos ? cleanKmLabel(row.maxima_velocidad, false) : undefined, filters.includeMovimientos);
        setIf('velocidadMaxCan', filters.includeMovimientos ? cleanKmLabel(row.vel_max_can, false) : undefined, filters.includeMovimientos);
        setIf('puntoCercano', row.pCercano, filters.includeParadas);
        setIf('velocidadPromedio', filters.includeMovimientos ? cleanKmLabel(row.vel_promedio, false) : undefined, filters.includeMovimientos);
        setIf('velocidadPromedioCan', filters.includeMovimientos ? cleanKmLabel(row.vel_prom_can, false) : undefined, filters.includeMovimientos);
        setIf('referencia', row.referencia, filters.includeParadas);

        return record;
      });
      let summary: VehicleSummary = {
        routeLength: resumen[0],
        movingDuration: resumen[1],
        stoppedDuration: resumen[2],
        maxSpeed: resumen[3],
        avgSpeed: resumen[4]
      }
      let vehicle = { name, imei }
      vehicleReport.vehicles.push({ records, vehicle, summary });
    })
    return vehicleReport;
  }

  // REPORTE DE PARADAS Y MOVIMIENTOS
  private formatReportStopsAndMoves2(payload: ReportPayload): VehicleReportData {
    const { filters } = payload;

    const vehicleReport: VehicleReportData = { vehicles: [] };

    (payload.data || []).forEach((vehicleData: any) => {
      const [vehicleInfo, dataList, parameters, resumen] = vehicleData;
      const imei = vehicleInfo?.[0];
      const name = vehicleInfo?.[1];
      if (!imei || !Array.isArray(dataList)) return;
      const records: ReportRecord[] = dataList.map((row: any, index: number) => {
        const record: ReportRecord = {
          item: index + 1,
          estado: row.estado,
          duracion: row.duracion,
          latitud: row.latitud,
          longitud: row.longitud,
        };

        const setIf = (
          key: keyof ReportRecord,
          value: any,
          condition = true
        ) => {
          if (condition && value != null) record[key] = value;
        };

        setIf(
          'fechaYHoraInicio',
          row.fecha,
          !filters.includeDateHour
        );
        if (
          filters.includeDateHour &&
          row.fecha
        ) {
          const [fecha, hora] = row.fecha.split(' ');
          setIf('fechaInicio', fecha);
          setIf('horaInicio', hora);
        }

        setIf(
          'fechaYHoraFin',
          row.fechasig,
          !filters.includeDateHour
        );
        if (
          filters.includeDateHour &&
          row.fechasig
        ) {
          const [fecha, hora] = row.fechasig.split(' ');
          setIf('fechaFin', fecha);
          setIf('horaFin', hora);
        }

        setIf(
          'ubicacion',
          row.latitud && row.longitud
            ? `${parseFloat(row.latitud).toFixed(6)}, ${parseFloat(
              row.longitud
            ).toFixed(6)}`
            : undefined,
          filters.includeParadas
        );
        record.ubicacionLink = filters.includeParadas ? `http://maps.google.com/maps?q=${parseFloat(row.latitud).toFixed(6)},${parseFloat(row.longitud).toFixed(6)}&t=m` : "";

        setIf('distanciaRecorrida', filters.includeMovimientos ? cleanKmLabel(row.recorrido, false) : undefined, filters.includeMovimientos);
        setIf('velocidadMaxGps', filters.includeMovimientos ? cleanKmLabel(row.maxima_velocidad, false) : undefined, filters.includeMovimientos);
        setIf('velocidadMaxCan', filters.includeMovimientos ? cleanKmLabel(row.vel_max_can, false) : undefined, filters.includeMovimientos);
        setIf('puntoCercano', row.pCercano, filters.includeParadas);
        setIf('nombreGeocerca', row.zonaDentro, filters.includeParadas);
        setIf('velocidadPromedio', filters.includeMovimientos ? cleanKmLabel(row.vel_promedio, false) : undefined, filters.includeMovimientos);
        setIf('velocidadPromedioCan', filters.includeMovimientos ? cleanKmLabel(row.vel_prom_can, false) : undefined, filters.includeMovimientos);
        setIf('referencia', row.referencia, filters.includeParadas);

        return record;
      });
      let summary: VehicleSummary = {
        routeLength: resumen[0],
        movingDuration: resumen[1],
        stoppedDuration: resumen[2],
        maxSpeed: resumen[3],
        avgSpeed: resumen[4]
      }
      let vehicle = { name, imei }
      vehicleReport.vehicles.push({ records, vehicle, summary });
    })
    return vehicleReport;
  }

  // REPORTE DE PRIMER MOVIMIENTO
  private formatReportFirstMovement(payload: ReportPayload): BasicReportData {
    const basicReport: BasicReportData = { records: [] };
    const filters = payload.filters;

    (payload.data || []).forEach((row: any, index: number) => {
      const record: ReportRecord = {
        item: index + 1,
        estado: row.estado,
        codigo: row.codigo,
        placa: row.placa ? row.placa.replace(/-/g, '') : '',
        latitud: row.latitud,
        longitud: row.longitud,

        fechaYHoraInicio: !filters.includeDateHour ? row.fecha_inicio : undefined,
        fechaInicio: filters.includeDateHour ? row.fecha_inicio.split(' ')[0] : undefined,
        horaInicio: filters.includeDateHour ? row.fecha_inicio.split(' ')[1] : undefined,

        fechaYHoraFin: !filters.includeDateHour ? row.fecha_fin : undefined,
        fechaFin: filters.includeDateHour ? row.fecha_fin.split(' ')[0] : undefined,
        horaFin: filters.includeDateHour ? row.fecha_fin.split(' ')[1] : undefined,

        duracion: row.duracion,
        distanciaRecorrida: cleanKmLabel(row.recorrido, false),
        velocidadMaxGps: cleanKmLabel(row.maxima_velocidad, false),
        velocidadMaxCan: cleanKmLabel(row.vel_max_can, false),
        puntoCercano: row.pCercano,
        velocidadPromedio: cleanKmLabel(row.vel_promedio, false),
        velocidadPromedioCan: cleanKmLabel(row.vel_prom_can, false),
        referencia: row.referencia,

        ubicacion: `${parseFloat(row.latitud).toFixed(6)}, ${parseFloat(row.longitud).toFixed(6)}`,
        ubicacionLink: `http://maps.google.com/maps?q=${parseFloat(row.latitud).toFixed(6)},${parseFloat(row.longitud).toFixed(6)}&t=m`,

        nombreGeocerca: row.zonaDentro,

      };


      basicReport.records.push(record);
    });

    return basicReport;
  }

}
